function copyOwnFrom(target, source) {
    Object.getOwnPropertyNames(source).forEach(function (propName) {
        Object.defineProperty(target, propName, Object.getOwnPropertyDescriptor(source, propName));
    });
    return target;
}
var InternalSymbol = /** @class */ (function () {
    function InternalSymbol(name, props) {
        this.name = name;
        if (props) {
            copyOwnFrom(this, props);
        }
        if (Object.freeze) {
            Object.freeze(this);
        }
    }
    InternalSymbol.prototype.toString = function () {
        return "|" + this.name + "|";
    };
    return InternalSymbol;
}());
export { InternalSymbol };
var Enum = /** @class */ (function () {
    function Enum(obj) {
        if (Array.isArray(obj)) {
            obj.forEach(function (name) {
                this[name] = new InternalSymbol(name);
            }, this);
        }
        else {
            Object.keys(obj).forEach(function (name) {
                this[name] = new InternalSymbol(name, obj[name]);
            }, this);
        }
    }
    Enum.prototype.toString = function (symbol) {
        if (this.contains(symbol)) {
            return symbol.toString();
        }
        throw new Error("symbol not part of this enum");
    };
    ;
    Enum.prototype.fromString = function (name) {
        if (name.substr(0, 1) === "|" && name.substr(-1, 1) === "|") {
            var sym = this[name.substring(1, name.length - 1)];
            if (sym instanceof InternalSymbol) {
                return sym;
            }
        }
        return null;
    };
    ;
    Enum.prototype.symbols = function () {
        var _this = this;
        return Object.keys(this).map(function (key) { return _this[key]; });
    };
    ;
    Enum.prototype.symbolPosition = function (symbol) {
        return this.symbols().indexOf(symbol);
    };
    ;
    Enum.prototype.contains = function (sym) {
        return this[sym.name] === sym;
    };
    ;
    return Enum;
}());
export default Enum;



//////////////////
// WEBPACK FOOTER
// ./js/asset/enum.ts
// module id = pO06
// module chunks = 1 2 3 4 5